var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h4',{staticClass:"notification-name"},[_vm._v(_vm._s(_vm.notificationName))]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.notificationMessage)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }